<template>
    <div style="display: flex; flex-direction: column; overflow:auto; flex-grow: 1; max-height: 100vh">
        <div v-loading="loading">
            <div class="t2t-inner-box" style="font-size: 1.5em; display: flex; justify-content: space-between">
                <div>
                    Fullfillment Request
                </div>
                <div>
                    <btn :click="() => show_dialogs.deny_request = true" icon="fas fa-ban" v-if="! is_readonly">Deny request</btn>
                    <btn :click="() => show_dialogs.cancel_request = true" icon="fas fa-pause" v-if="! is_readonly">Pause campaigns</btn>
                    <btn :click="reopenRequest" icon="fas fa-play" v-if="is_readonly">Reopen</btn>
                </div>
            </div>

            <div class="ui-inner-box">
                <fulfillment-detail-request :fulfillment="fulfillment" :job="job" :lists="lists" @changed="refresh" :readonly="is_readonly"></fulfillment-detail-request>
        
                <div class="mb-5">
                    <div class="row">
                        <div class="col-4">
                            <fulfillment-detail-leads :fulfillment="fulfillment"@changed="refresh" :readonly="is_readonly"></fulfillment-detail-leads>
                        </div>
                    </div>
                </div>

                <fulfillment-detail-ja-campaigns :fulfillment="fulfillment" :ja_campaigns="ja_campaigns.list" :sums="ja_campaigns.sums" :readonly="is_readonly" @changed="refresh"></fulfillment-detail-ja-campaigns>
                <fulfillment-detail-notes :fulfillment="fulfillment" @changed="refresh" :readonly="is_readonly"></fulfillment-detail-notes>
                <fulfillment-detail-settings :fulfillment="fulfillment" @changed="refresh" :readonly="is_readonly"></fulfillment-detail-settings>
            </div>

            <fulfillment-dialog-deny-request
                :show="show_dialogs.deny_request"
                :fulfillment_id="fulfillment_id"
                :fulfillment="fulfillment"
                @changed="refresh" 
                @close="show_dialogs.deny_request = false"
            >
            </fulfillment-dialog-deny-request>
            <fulfillment-dialog-cancel-request
                :show="show_dialogs.cancel_request"
                :fulfillment_id="fulfillment_id"
                @changed="refresh" 
                @close="show_dialogs.cancel_request = false"
            >
            </fulfillment-dialog-cancel-request>
        </div>
    </div>
</template>

<script>
import FulfillmentDetailRequest from "./fulfillment-detail/fulfillment-detail-request";
import FulfillmentDetailLeads from "./fulfillment-detail/fulfillment-detail-leads";
import FulfillmentDetailJaCampaigns from "./fulfillment-detail/fulfillment-detail-ja-campaigns";
import FulfillmentDetailNotes from "./fulfillment-detail/fulfillment-detail-notes";
import FulfillmentDetailSettings from "./fulfillment-detail/fulfillment-detail-settings";
import FulfillmentDialogDenyRequest from "./fulfillment-detail/fulfillment-dialog-deny-request";
import FulfillmentDialogCancelRequest from "./fulfillment-detail/fulfillment-dialog-cancel-request";

export default {
        props: [
            'fulfillment_id',
        ],
        components: {
            FulfillmentDetailRequest,
            FulfillmentDetailLeads,
            FulfillmentDetailJaCampaigns,
            FulfillmentDetailNotes,
            FulfillmentDetailSettings,
            FulfillmentDialogDenyRequest,
            FulfillmentDialogCancelRequest
        },
        data() {
            return {
                loading: true,
                fulfillment: {},
                job: {},
                ja_campaigns: {
                    list: [],
                    sums: [],
                },
                history: [],
                show_dialogs: {
                    deny_request: false,
                    cancel_request: false
                },
                is_readonly: false,
                lists: {
                    order_types: [],
                }
            }
        },
        watch: {
        },
        computed: {
        },
        methods: {
            refresh() {
                this.loading = true;

                return axios.get(url(`de/fulfillment/${this.fulfillment_id}/detail`))
                    .then((response) => {
                        this.fulfillment = response.data.fulfillment;
                        this.is_readonly = response.data.is_readonly;
                        this.job = response.data.job;
                        this.ja_campaigns = response.data.ja_campaigns;
                        this.history = response.data.history;
                        this.lists = response.data.lists;

                        this.loading = false;
                    })
            },
            reopenRequest() {
                return axios.post(url(`de/fulfillment/${this.fulfillment_id}/reopen`), {
                }).then((response) => {
                    this.refresh();
                });
            }
        },
        mounted() {
        },
        created() {
            this.refresh();
        },
    }
</script>

<style>
</style>